/**
 * @module app.um
 */

import { autoinject } from 'aurelia-framework';
import { Api } from 'app/shared/lib/essette-api';
import { IApiActionResults } from 'app/shared/lib/api/api-types';
import * as Core from 'app/core/models/essette-api';
import * as UM from 'app/um/models/essette-api';

@autoinject()
export class TrackingService {

    ////****************** Functions ************************************************////
    constructor(private readonly api: Api) { }

    ////****************** Queries **************************************************////

    public async trackAuthQueueUsers(authQueueId: string, trackingQueue: ITrackingQueue): Promise<ITrackActionResults> {
        const action = this.api.action('track', `um/auths/queues/${authQueueId}`, trackingQueue);
        return await this.api.post(action);
    }

    public async trackPortalQueueUsers(portalQueueId: string, trackingQueue: ITrackingQueue): Promise<ITrackActionResults> {
        const action = this.api.action('track', `um/portal/queues/${portalQueueId}`, trackingQueue);
        return await this.api.post(action);
    }
}

export interface ITrackAuth extends UM.Auth {
    users?: Core.User[];
}

export interface ITrackingQueue {
    auths?: {
        id: string | null | undefined
    }[]
}

export interface ITrackActionResult {
    auths?: ITrackAuth[];
}

export interface ITrackActionResults extends IApiActionResults {
    result: ITrackActionResult;
}
